//import UIkit from 'uikit';
import $ from "jquery";

window.addEventListener("px-ready", function () {
  var $ = jQuery;

  $(window).on('resize',function(){
    var height = $('.px-header').outerHeight();
    if($('.px-breadcrumb').length){
      height += $('.px-breadcrumb').outerHeight();
    }
    console.log(height);
    $('.px-popup-searchform').css('top',height+'px');
    $('.px-popup-searchform').css('height', 'calc(100vh - '+height+'px)');
    $('.popin-searchform-body').css('max-height','calc(100% - '+$('.popin-searchform-head').outerHeight()+'px)')
  })

  $('.js-form-clear').on('click',function(){
    $(this).parent().find('input').val('');
    $(".px-popup-searchform input,.px-form-search input").trigger("keydown");
    $(".autocomplete-suggestions>div,.autocomplete-suggestions>a,.autocomplete-suggestions-page>div,.autocomplete-suggestions-page>a").remove();
    console.log('clear');
  })
  $(".js-open-searchform").click(function () {
    if($('body').attr('clicklock') != 1){
      $('body').attr('clicklock',1)
      if(!$("body").hasClass("is-searchform-shown")){
        $("body").addClass("is-searchform-shown");
        $("body").addClass("is-overlay-visible");
        $(window).trigger('resize');
        jQuery("html, body").animate({ scrollTop: 0 }, 200);
        $('.popin-searchform-head input[name="s"]').focus();
      }else{
        $("body").removeClass("is-searchform-shown");
        $("body").removeClass("is-overlay-visible");
      }
      window.setTimeout(function(){$('body').attr('clicklock',0);},30);
    }
    return false;
  });
  $(".px-popup-searchform .close")
    .click(function () {
      $("body").removeClass("is-searchform-shown");
      $("body").removeClass("is-overlay-visible");
    })
    .trigger("click");

  $(".px-popup-searchform,.px-form-search").on("keydown", "input", function () {
    var inputVar = $(this);
    if(inputVar.val() == ''){
      $('.js-form-clear').css('opacity',0)
    }else{
      $('.js-form-clear').css('opacity',1)
    }
    window.setTimeout(function () {
      inputVar.parent().attr("data-space", inputVar.val());
    }, 50);
  });
  $(".px-popup-searchform input,.px-form-search input").trigger("keydown");

  var searchRequest,
    urls = [],
    extracts = [],
    matches = [];
  $(window)
    .on("scroll", function () {
      jQuery(".search-autocomplete").autoComplete("update");
    })
    .trigger("scroll");
  jQuery(".search-autocomplete")
    .autoComplete({
      minChars: 2,
      onSelect: function (e, term) {
        window.location = urls[matches.indexOf(term)];
      },
      source: function (term, suggest) {
        try {
          searchRequest.abort();
        } catch (e) {}
        searchRequest = $.get(autocompleteurl, {}, function (res) {
          var len = res.length,
            regex = new RegExp(term, "gi");
          urls = [];
          matches = [];

          for (var i = 0; i < len; i++) {
            if (res[i].title.match(regex)) {
              matches.push(res[i].title);
              urls.push(res[i].url);
              extracts.push(res[i].extract)
            }
          }
          console.log(matches);
          px_add_matches(matches, term, urls, extracts);
          //suggest(matches);
        });
      },
    })
    .trigger("keydown keyup change");
  jQuery(".search-autocomplete").autoComplete("update");
});

function px_add_matches(matches, term, urls, extracts) {
  var hasMatches = false;
  $(".autocomplete-suggestions>div,.autocomplete-suggestions>a, .autocomplete-suggestions>hr").remove();
  console.log(urls);
  $.each(matches, function (index, value) {
    //console.log(value);
    var url = urls[index];
    var extract = extracts[index];
    //console.log(url);
    var px_pattern = new RegExp(escape(term), "gi");
    $(".autocomplete-suggestions").append(
      '<div class="px-search-result mb-7">'+
          '<h4 class="mb-2">'+
            '<a href="' + url + '" class="text-secondary">' + value.replace(px_pattern, "<span>$&</span>") + "</a>"+
          "</h4>"+
          extract+
        "</div>"
    );
    hasMatches = true;
  });
  $(".autocomplete-suggestions").append('<hr />')
  console.log(hasMatches);
  if (hasMatches && term) {
    $(".autocomplete-suggestions").addClass("has-matches");
    $(".px-popup-searchform").addClass("has-matches");
  } else {
    $(".autocomplete-suggestions").removeClass("has-matches");
    $(".px-popup-searchform").removeClass("has-matches");
  }

  //onpage
  var hasMatches = false;
  $(".autocomplete-suggestions-page>div,.autocomplete-suggestions-page>a").remove();
  console.log(urls);
  $.each(matches, function (index, value) {
    //console.log(value);
    var url = urls[index];
    var extract = extracts[index];
    //console.log(url);
    console.log(matches);
    var px_pattern = new RegExp(escape(term), "gi");
    $(".autocomplete-suggestions-page").append(
      '<div class="px-search-result mb-7">'+
          '<h4 class="mb-2">'+
            '<a href="' + url + '" class="text-secondary">' + value.replace(px_pattern, "<span>$&</span>") + "</a>"+
          "</h4>"+
          extract+
        "</div>"
    );
    hasMatches = true;
  });
  console.log(hasMatches);
  if (hasMatches && term) {
    $(".autocomplete-suggestions").addClass("has-matches");
    $(".px-popup-searchform").addClass("has-matches");
  } else {
    $(".autocomplete-suggestions").removeClass("has-matches");
    $(".px-popup-searchform").removeClass("has-matches");
  }
}
